import {AfterViewInit, Component, OnInit, ViewChild} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {AddAddressComponent} from '../profile/add-address/add-address.component';
import {AuthenticationService, GoogleAnalyticsService, UserService} from '../../../core/service';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {HttpErrorResponse} from '@angular/common/http';
import {takeUntil, tap} from 'rxjs/operators';
import {Observable, of, Subject, Subscription} from 'rxjs';
import {Patch} from 'app/core/models/patch';
import {UserAddress} from '../../../core/models/user-address';
import {GetUserAddressesRequest} from '../../../core/requests/GetUserAddressesRequest';
import {GetUserAddressesResponse} from '../../../core/responses/GetUserAddressesResponse';
import {AddBeneficiaryComponent} from './add-beneficiary/add-beneficiary.component';
import {TranslatePipe, TranslateService} from '@ngx-translate/core';
import {BenefitSummaryService} from '../../../core/service/benefit-summary.service';
import {ActivatedRoute, Router} from '@angular/router';
import {GetBenefitResponse} from '../../../core/responses/GetBenefitResponse';
import {FlexibleBenefit} from '../../../core/models/flexible-benefit';
import {Beneficiary} from '../../../core/models/beneficiary';
import {BenefitDocument} from '../../../core/models/benefit-document';
import {GetDocumentsRequest} from '../../../core/requests/GetDocumentsRequest';
import {GetBenefitDocumentsResponse} from '../../../core/responses/GetBenefitDocumentsResponse';
import {Card} from '../../../core/models/card';
import {CoreLoadingScreenService} from '../../../../@core/services/loading-screen.service';
import {
  AcquisitionType,
  BENEFIT_TYPE_LABEL,
  BenefitType,
  CompanyTaxDistribution,
  GIFT_TICKET_CATEGORY_ID,
  maskCnp,
  maskEmail,
  maskPhoneNumber,
  PricingPlan,
  SHIPPING_TYPE_LABEL,
  ShippingType
} from '../../../core/helpers/constants';
import {GetBeneficiariesResponse} from '../../../core/responses/GetBeneficiariesResponse';
import {PaginationCriteria} from '../../../core/requests/PaginationCriteria';
import {PaymentService} from '../../../core/service/payment.service';
import {GetTaxInfoResponse} from '../../../core/responses/GetTaxInfoResponse';
import {PostOrderRequest} from '../../../core/requests/PostOrderRequest';
import {BaseResponse} from '../../../core/responses/BaseResponse';
import {User} from '../../../core/models';
import {PostOrderResponse} from '../../../core/responses/PostOrderResponse';
import {ShowBenefitComponent} from '../../shared/show-benefit/show-benefit.component';
import {ToastrService} from 'ngx-toastr';
import {BenefitTaxes} from '../../../core/models/benefit-taxes';
import {GiftTicketsService} from 'app/core/service/gift-tickets.service';
import {SubscriptionPaymentModel} from 'app/core/models/subscription-payments';
import {GetSubcriptionPaymentsResponse} from 'app/core/responses/GetSubscriptionPaymentsResponse';
import {SubdomainInfo} from 'app/core/models/subdomain-info';
import {DomSanitizer} from '@angular/platform-browser';
import {DynamicAttribute} from 'app/core/models/dynamic-attribute';
import {TaxAndFeesTooltipService} from 'app/core/service/tax-and-fees-tooltip.service';
import {TaxService} from "../../../core/service/tax.service";
import {BenefitPaymentType, RaiffeisenFormData} from "../../../core/helpers/enums";
import {RaiffeisenBranchData} from "../../../core/models/raiffeisen-branch-data";
import {DashboardService} from "../../../core/service/dashboard.service";
import {redirectToPaymentGateway} from "../../../core/helpers/payment-redirect.helper";
import {ErrorMessage, OrderErrorPriority} from "../../shared/error-messages/error-messages.component";
import {DatePipe} from "@angular/common";
import {
  CompanyBenefitPolicyCheckoutDTO,
  CompanyBenefitPolicyRequiredCheckboxDTO,
  CompanyBenefitPolicyRequiredDocumentDTO,
  CompanyBenefitPolicyRequiredFieldDTO,
} from '../../../core/models/company-benefit-policy';
import {GetBenefitCheckoutPolicyResponse} from '../../../core/responses/GetBenefitCheckoutPolicyResponse';
import {Base64File} from '../../../core/models/fileValidation';
import {OrderSubmittedDocumentSubmissionModel} from '../../../core/models/order-policy-submission';
import {ResponseError} from '../../../core/responses/ResponseError';
import {RequiredConsentsComponent} from '../../shared/required-consents/required-consents.component';
import {RequiredFieldsComponent} from '../../shared/required-fields/required-fields.component';

export interface RaiffeisenBranchOption {
  countyName: string;
  cityName: string;
  branchDetails: RaiffeisenBranchData;
  displayName: string;
}

interface RequiredDocumentState extends CompanyBenefitPolicyRequiredDocumentDTO {
  uploadedFile: Base64File | null;
}

interface PolicyUploadFile extends File {
  progress?: number;
}

@Component({
  selector: 'app-benefit-summary',
  templateUrl: './benefit-summary.component.html',
  styleUrls: ['./benefit-summary.component.scss'],
  providers: [TranslatePipe, DatePipe],
})
export class BenefitSummaryComponent implements OnInit, AfterViewInit {

  public userName: string;
  public benefit: FlexibleBenefit = null;
  public benefitId: number = null;
  public beneficiaries: Array<Beneficiary> = null;
  public documents: Array<BenefitDocument> = null;
  public cards: Array<Card> = null;

  // Masks a phone number for read-only display (e.g. beneficiary cards),
  // keeping only the last 4 digits visible.
  public maskPhone(phone: string): string {
    return maskPhoneNumber(phone);
  }

  // Masks a CNP for read-only display, keeping only the last 6 digits
  // visible.
  public maskCnp(cnp: string): string {
    return maskCnp(cnp);
  }

  // Masks an email for read-only display, e.g. "abc***@*il.com".
  public maskEmail(email: string): string {
    return maskEmail(email);
  }
  public billingAddresses: Array<UserAddress> = null;
  public shippingAddresses: Array<UserAddress> = null;
  public userInfoDashboard: User = null;
  private ngUnsubscribe = new Subject();
  public quantity = 1;
  public meta: any;
  public selectedBeneficiary = '0';
  public selectedShippingAddress = 0;
  public selectedBillingAddress = 0;
  public selectedCard = '0';
  public tosDocumentUrl = '';
  public shippingTypes = ShippingType;
  public benefitTaxes: BenefitTaxes;
  public companyId: number;
  public companyTaxDistribution: CompanyTaxDistribution;
  public subscriptionPayments: SubscriptionPaymentModel[];
  public BenefitType = BenefitType;
  public AcquisitionType = AcquisitionType;
  public benefitIsTicket = false;
  public benefitIsSubscription = false;
  public benefitIsAutoOrder = false;
  public isAutoOrderEnabled = false;
  public allDocumentsRead = false;
  public benefitIs24Pay = false;
  public processorIsRaiffeisen = false;
  public form24Pay: FormGroup | null = null;
  public formRaiffeisen: FormGroup | null = null;
  public raiffeisenBranches: Record<string, Record<string, RaiffeisenBranchData[]>> = {};
  public isCardPayment: boolean = false;
  public isSalaryPayment: boolean = false;
  giftTickets: any;
  canBeOrdered = true;
  remainingEventLimit: number | null = null;
  eventLimitOverflowAmount: number | null = null;
  activeEventName: string | null = null;
  cardPaymentBlocked = false;
  verifyCanOrderWarningMessage: string | null = null;
  totalAmountWithVat: number;
  private userDashboardSubscription: Subscription;
  differenceWithCard: number;
  taxAndFeesTooltipText: string;
  public userCompanyInfo: SubdomainInfo;
  amountFromStandardBudget: number;
  amountFromTransportBudget: number;
  amountFromProfessionalDevelopmentBudget: number;
  amountFromCashbackBudget: number;
  usesStandardBudget: boolean;
  usesProfessionalDevelopmentBudget: boolean;
  usesTransportBudget: boolean;
  usesDifferenceWithCard: boolean;
  usesCashbackBudget = false;
  showCardPayment = false;
  orderId: number = null;
  canNotFulfillPayment: SubscriptionPaymentModel = undefined;
  private dynamicQuantity = false;
  subdomain: string;
  dynamicFieldRequiredError: string;
  dynamicFieldPatternError: string;
  public raiffeisenBranchesOptions: RaiffeisenBranchOption[] = null;
  public errorMessages: ErrorMessage[] = [];
  public requiredDocuments: RequiredDocumentState[] = [];
  public policyCheckboxes: CompanyBenefitPolicyRequiredCheckboxDTO[] = [];
  public policyRequiredFields: CompanyBenefitPolicyRequiredFieldDTO[] = [];
  public selectedPolicyFiles: PolicyUploadFile[] = [];
  public checkoutPolicy: CompanyBenefitPolicyCheckoutDTO | null = null;
  public hasActiveCheckoutPolicy = false;
  public checkoutPolicyLoadFailed = false;
  private checkoutBackendErrors: ErrorMessage[] = [];
  public requiredFieldErrors: Record<number, string> = {};
  @ViewChild(RequiredConsentsComponent) private requiredConsentsRef: RequiredConsentsComponent;
  @ViewChild(RequiredFieldsComponent) private requiredFieldsRef: RequiredFieldsComponent;

  constructor(
    private modalService: NgbModal,
    private userService: UserService,
    private authenticationService: AuthenticationService,
    private benefitSummaryService: BenefitSummaryService,
    private paymentService: PaymentService,
    private _route: ActivatedRoute,
    private _router: Router,
    private translate: TranslatePipe,
    protected translateService: TranslateService,
    private loadingScreenService: CoreLoadingScreenService,
    private _toastrService: ToastrService,
    private _giftTicketService: GiftTicketsService,
    private sanitized: DomSanitizer,
    private taxAndFeesService: TaxAndFeesTooltipService,
    private taxService: TaxService,
    private gAnalyticsService: GoogleAnalyticsService,
    private route: ActivatedRoute,
    private dashboardService: DashboardService,
    private datePipe: DatePipe,
  ) {
    this.subdomain = this._route.snapshot.params['subdomain'];
    this.benefitId = this._route.snapshot.params.id || '';
    this.quantity = this._route.snapshot.params.quantity || '';
    this.meta = this._route.snapshot.params.meta || '';
    this.authenticationService.currentUserCompanyInfo.subscribe((x) => {
      if (x) {
        this.userCompanyInfo = x;
        this.tosDocumentUrl = x.tosDocumentUrl;
      }
    });
    this.userDashboardSubscription = this.authenticationService.currentUserInfo.subscribe((x) => {
      this.userInfoDashboard = x;
      this.userName = x.firstName + ' ' + x.lastName;
    });

  }

  @ViewChild('dynamicContainer') dynamicContainer;

  ngAfterViewInit() {
    setTimeout(() => {
      const panel = document.querySelector('.ng-dropdown-panel');
      if (panel) {
        panel.classList.add('long-option-text-ng-select');
      }
    });
  }

  ngOnInit() {
    this.loadBenefit();
    this.loadBeneficiaries();
    this.loadDocuments();
    this.companyId = this.authenticationService.currentUserValue.companyId;
    this.companyTaxDistribution = this.authenticationService.currentUserInfoValue.companyTaxDistribution;
    this.showTaxesForCompany = !this.taxService.hideTaxes(this.companyTaxDistribution, this.companyId);
    this.route.queryParams.subscribe(params => {
      this.isCardPayment = params['paymentType'] === "card";
      this.isSalaryPayment = params['paymentType'] === "salary";
    });
    this.updateDynamicFieldErrors();
    this.translateService.onLangChange.subscribe(() => {
      this.updateDynamicFieldErrors();
      this.collectErrors();
    });
  }

  private updateDynamicFieldErrors() {
    this.dynamicFieldRequiredError = this.translate.transform("DYNAMIC_ATTRIBUTES.ERRORS.REQUIRED");
    this.dynamicFieldPatternError = this.translate.transform("DYNAMIC_ATTRIBUTES.ERRORS.INVALID_VALUE");
  }

  get beneficiaryId(): number {
    return Number.parseInt(this.selectedBeneficiary, 10);
  }

  /**
   * Get benefit
   */

  public loadBenefit() {

    this.benefitSummaryService
      .getBenefit(this.benefitId)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (data) => {
          this.onGetBenefitSuccess(data);
        },
        (error) => {
          this.onGetBenefitFail(error);
        }
      );
  }

  public onGetBenefitSuccess(data: GetBenefitResponse) {
    this.benefit = Object.assign(
      new FlexibleBenefit(),
      data.responseObject,
      {
        shippingTypeLabel: SHIPPING_TYPE_LABEL[data.responseObject.shippingType],
        parsedExpirationDate: new Date(
          Date.parse(data.responseObject.expirationDate)
        ).toLocaleString(),
      }
    );

    this.gAnalyticsService.addGeneralEventsAnalytics('event', 'begin_checkout', {
      currency: 'RON',
      value: this.benefit.price * this.quantity,
      items: [{
        item_id: this.benefit.id,
        item_sku: this.benefit.sku,
        item_name: this.benefit.name,
        item_category: this.benefit.categoryName,
        item_category_id: this.benefit.categoryId,
        item_brand: this.benefit.providerName,
        price: this.benefit.price,
        quantity: this.quantity,
        affiliation: this.benefit.providerName,
        vat_included: this.benefit.includesVat,
        vat_percentage: this.benefit.vatPercentage,
        card_payment_allowed: this.benefit.hasCreditCardAllowed(),
        tax_type: this.benefit.benefitTaxCategory,
        supplier_id: this.benefit.providerId,
        benefit_Type: this.benefit.benefitTypeId,
      }]
    });

    this.benefitIs24Pay = this.is24PayBenefit();
    if(this.benefitIs24Pay) {
      var userPhoneNumber = this.authenticationService.currentUserValue.phoneNumber;
      if (userPhoneNumber!= null && !userPhoneNumber.startsWith('+')) {
        userPhoneNumber = '+4' + userPhoneNumber;
      }
      this.form24Pay = new FormGroup({
        phoneNumber: new FormControl(userPhoneNumber || "+40", [
          Validators.required,
          Validators.pattern('^\\+4[0-9]{10}$'),
        ])
      });
    }
    this.benefitIsSubscription = this.isSubscriptionBenefit();
    this.benefitIsAutoOrder = this.isAutoOrderBenefit();
    this.benefitIsTicket = this.isTicketBenefit();
    this.benefit.benefitTypeLabel = this.getBenefitTypeLabel(data.responseObject.benefitTypeId);
    this.benefit.dynamicAttributesSafeHtml = this.sanitized.bypassSecurityTrustHtml(this.benefit.dynamicAttributesHtml);

    this.taxAndFeesTooltipText = this.taxAndFeesService.setTaxAndFeesTooltip(this.benefit, false);
    this.getSubscriptionPayments();
    this.getTaxes();
    this.loadActiveEventName();

    setTimeout(() => {
      const scripts = this.dynamicContainer.nativeElement.getElementsByTagName('script');
      for (const script of scripts){
        // eslint-disable-next-line no-eval
        eval(script.text);
      }
    });

    if(this.hasBillingAddress()) {
      this.getUserAddresses('billing');
    }

    if(this.benefit.shippingType !== this.shippingTypes.Voucher &&
      this.benefit.shippingType !== this.shippingTypes.CardRecharge &&
      this.benefit.shippingType !== this.shippingTypes.Email){
      this.getUserAddresses('shipping');
    }
    this.loadCheckoutPolicy()
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe({
        error: error => {
          this.onCheckoutPolicyFail(error);
        }
      });
    // collectErrors() intentionally not called here — getTaxes(),
    // getSubscriptionPayments() and loadActiveEventName()/verifyCanOrder()
    // each invoke it once their async work completes.
  }

  public onGetBenefitFail(error: HttpErrorResponse) { }

  private listenersSet = false;

  public hasBillingAddress() {
    return (this.benefit.providerName.toLowerCase().includes('worldclass') ||
      this.benefit.benefitTypeId === BenefitType.PrivatePensionPillarIII ||
      this.benefit.benefitTypeId === BenefitType.MedicalServicesOrInsurance);
  }

  public getBenefitTypeLabel( benefitTypeId: number) {
    if(this.benefitIsTicket) {
      return BENEFIT_TYPE_LABEL[this.benefit.benefitTypeId];
    }
    if(this.benefit.benefitTypeId === BenefitType.Product) {
      return 'BENEFIT_SUMMARY.SUMMARY_DETAILS.PRODUCT';
    }
    return 'BENEFIT_SUMMARY.SUMMARY_DETAILS.BENEFIT';
  }

  /**
   * Get Taxes for selected benefit
   */

  public getTaxes() {
    this.paymentService
      .getTaxForBenefit(
        this.benefit.id,
        this.quantity,
        this.selectedBeneficiary !== '0' && this.benefit.categoryId !== GIFT_TICKET_CATEGORY_ID,
        this.meta,
        this.isCardPayment,
        this.isSalaryPayment
      )
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (data) => {
          this.onGetTaxesSuccess(data);
        },
        (error) => {
          this.onGetTaxesFail(error);
        }
      );
  }

  public onGetTaxesSuccess(data: GetTaxInfoResponse) {
    this.benefitTaxes = data.responseObject;
    this.totalAmountWithVat = this.taxService.getAmountToPayFromBenefitTaxes(this.benefitTaxes, this.benefitTaxes.taxDistributionType);
    if(this.isCardPayment){
      this.amountFromStandardBudget = 0;
      this.differenceWithCard = this.totalAmountWithVat;
      this.getUserAddresses('billing');
    } else if(this.isSalaryPayment){
      // Paid entirely from salary — no budget is used and no card difference applies,
      // but the employee still supports their tax share like on a budget payment.
      this.usesDifferenceWithCard = false;
      this.usesStandardBudget = this.usesProfessionalDevelopmentBudget = this.usesTransportBudget = this.usesCashbackBudget = false;
      this.amountFromStandardBudget = 0;

      this.collectErrors();
    } else{
      this.usesDifferenceWithCard = false;

      // Initialize all budget usages flags to false
      this.usesStandardBudget = this.usesProfessionalDevelopmentBudget = this.usesTransportBudget = false;
      // Enable budget usage depending on the benefit type
      if(this.benefit.benefitTypeId === BenefitType.Transport && this.userCompanyInfo.hasTransportBudget && this.userInfoDashboard.totalAmountTransport > 0) {
        this.usesTransportBudget = true;
        this.PayFromTransportBudget(this.totalAmountWithVat);
      } else if(this.benefit.benefitTypeId === BenefitType.ProfessionalDevelopment && this.userCompanyInfo.hasProfessionalDevelopmentBudget && this.userInfoDashboard.totalAmountProfessionalDevelopment > 0) {
        this.usesProfessionalDevelopmentBudget = true;
        this.PayFromProfessionalDevelopmentBudget(this.totalAmountWithVat);
      } else {
        this.usesStandardBudget = true;
        this.PayFromStandardBudget(this.totalAmountWithVat);
      }

      this.collectErrors();
    }
  }

  public onGetTaxesFail(error: HttpErrorResponse) { }

  private PayFromProfessionalDevelopmentBudget(amount: number) {
    if (amount > this.userInfoDashboard.totalAmountProfessionalDevelopment) {
      this.amountFromProfessionalDevelopmentBudget = this.userInfoDashboard.totalAmountProfessionalDevelopment;
      this.PayFromStandardBudget(amount - this.userInfoDashboard.totalAmountProfessionalDevelopment);
    } else {
      this.amountFromProfessionalDevelopmentBudget = amount;
    }
  }

  private PayFromTransportBudget(amount: number) {
    if (amount > this.userInfoDashboard.totalAmountTransport) {
      this.amountFromTransportBudget = this.userInfoDashboard.totalAmountTransport;
      this.PayFromStandardBudget(this.totalAmountWithVat - this.amountFromTransportBudget);
    } else {
      this.amountFromTransportBudget = amount;
    }
  }

  private PayFromStandardBudget(amount: number) {
    if (this.userCompanyInfo.pricingPlan === PricingPlan.LITE) {
      this.usesStandardBudget = false;
      this.amountFromStandardBudget = 0;
      this.PayFromCashbackBudget(amount);
      return;
    } else {
      this.usesStandardBudget = true;
      if (amount > this.userInfoDashboard.totalAmount) {
        this.amountFromStandardBudget = this.userInfoDashboard.totalAmount;
        this.PayFromCashbackBudget(amount - this.userInfoDashboard.totalAmount);
      } else {
        this.amountFromStandardBudget = amount;
      }
    }
  }

  private PayFromCashbackBudget(amount: number) {
    this.usesCashbackBudget = this.userInfoDashboard.totalAmountCashback !== null && this.userInfoDashboard.totalAmountCashback > 0;
    if (!this.usesCashbackBudget) {
      this.setDifferenceWithCard(amount);
    } else {
      if (amount > this.userInfoDashboard.totalAmountCashback) {
        this.amountFromCashbackBudget = this.userInfoDashboard.totalAmountCashback;
        this.setDifferenceWithCard(amount - this.amountFromCashbackBudget);
      } else {
        this.amountFromCashbackBudget = amount;
      }
    }
  }

  public setDifferenceWithCard(amount: number): void {
    this.usesDifferenceWithCard = true;
    this.differenceWithCard = amount;

    if(this.benefit.hasCreditCardAllowed() === true && (this.usesDifferenceWithCard === true || this.isCardPayment) && !this.hasBillingAddress()) {
      this.getUserAddresses('billing');
    }
  }

  /**
   * Post order
   */
  public postOrder() {
    let form = null;
    if(this.hasDynamicFields()) {
      form = this.dynamicContainer.nativeElement.querySelector('form');
      const formHasErrors = this.checkFormValues(form);
      if(formHasErrors){
        return;
      }
    }

    if (this.processorIsRaiffeisen) {
      if (this.formRaiffeisen.invalid) return;
      if (this.selectedBillingAddress === 0 ||
        (this.selectedBillingAddress !== 0 && !this.isBillingContactNameSameAsUsername())
      ) {
        return;
      }
    }

    if(!this.canBeOrdered) {
      return;
    }
    this.refreshCheckoutPolicyAndSubmit(form);
  }

  private refreshCheckoutPolicyAndSubmit(form: HTMLFormElement | null): void {
    const hasRequiredDocumentsToSubmit = this.requiredDocuments.some((document) => !!document.uploadedFile?.base64Value);
    const uploadMessage = hasRequiredDocumentsToSubmit ? this.translate.transform('UPLOAD_FILE.UPLOAD_IN_PROGRESS') : undefined;
    this.loadingScreenService.show(uploadMessage);
    this.requiredFieldErrors = {};

    const continueSubmit = () => {
      const requirementsErrorKey = this.getOrderRequirementsErrorKey();
      if (requirementsErrorKey) {
        this.loadingScreenService.hide();
        this.collectErrors();
        this._toastrService.error(
          this.translate.transform(requirementsErrorKey),
          this.translate.transform('ERROR'),
          { toastClass: 'toast ngx-toastr', closeButton: true, timeOut: 8000 }
        );
        return;
      }

      this.submitOrder(form);
    };

    this.loadCheckoutPolicy()
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe({
        next: () => continueSubmit(),
        error: (error) => {
          this.onCheckoutPolicyFail(error);
          this.loadingScreenService.hide();
        }
      });
  }

  /**
   * Returns the translation key describing the first unmet order requirement,
   * or null when the order can be submitted.
   */
  private getOrderRequirementsErrorKey(): string | null {
    if (!this.checkDocsStatus()) {
      return 'BENEFIT_SUBSCRIPTION_PAYMENT_RETRY.READ_DOCUMENTS';
    }
    if (!this.isCheckoutPolicyComplete()) {
      return 'BENEFIT_SUMMARY.CHECKOUT_POLICY.INCOMPLETE';
    }
    if (!this.checkIfShippingIsRequired() || !this.checkIfBillingAddressIsRequired()) {
      return 'BENEFIT_SUBSCRIPTION_PAYMENT_RETRY.ORDER_REQUIREMENTS';
    }
    return null;
  }

  private submitOrder(form: HTMLFormElement | null): void {
    this.authenticationService.isDirty = true;
    if (this.userDashboardSubscription) {
      this.userDashboardSubscription.unsubscribe();
    }

    // TODO only save card if requested in UI
    // this will initiate a NETOPIA payment or be a simple payment dependint on the amount in the user balance
    const params: PostOrderRequest = {
      benefitId: this.benefit.id,
      billingAddressId: this.selectedBillingAddress,
      newCard: false,
      cardInfoId: Number.parseInt(this.selectedCard, 10),
      noOfUnits: this.quantity,
      saveCard: false,
      shippingAddressId: this.selectedShippingAddress,
      userId: this.authenticationService.currentUserValue.userId,
      beneficiaryId: this.beneficiaryId > 0 ? this.beneficiaryId : null,
      phoneNumber: this.form24Pay != null ? this.form24Pay.controls.phoneNumber.value : this.authenticationService.currentUserValue.phoneNumber,
      isAutoOrderEnabled: this.isAutoOrderEnabled,
      isAutoOrderDynamicQuantity: this.dynamicQuantity,
      meta: decodeURIComponent(this.meta),
      dynamicAttributes: this.formRaiffeisen ? this.extractRaiffeisenFormValues() : this.extractFormValues(form),
      payWithCardOnly: this.isCardPayment,
      submittedRequiredDocuments: this.buildSubmittedRequiredDocuments(),
      submittedConsents: this.requiredConsentsRef?.getSubmittedConsents() ?? [],
      submittedRequiredFields: this.requiredFieldsRef?.getSubmittedFields() ?? [],
      payFromSalary: this.isSalaryPayment
    };

    this.paymentService
      .postSimpleOrder(params)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe({
        next: (data) => {
          this.onPostPartialOrderSuccess(data);
          this.loadingScreenService.hide();
        },
        error: error => {
          this.onPostOrderFail(error);
          this.loadingScreenService.hide();
        }
      });
  }

  private fetchCheckoutPolicy(): Observable<GetBenefitCheckoutPolicyResponse | null> {
    if (!this.benefitId) {
      return of(null);
    }

    return this.benefitSummaryService.getBenefitCheckoutPolicy(this.benefitId);
  }

  public loadCheckoutPolicy(): Observable<GetBenefitCheckoutPolicyResponse | null> {
    return this.fetchCheckoutPolicy().pipe(
      tap((data: GetBenefitCheckoutPolicyResponse | null) => {
        this.applyCheckoutPolicy(data?.responseObject ?? null);
      })
    );
  }

  private applyCheckoutPolicy(policy: CompanyBenefitPolicyCheckoutDTO | null): void {
    this.checkoutPolicy = policy;
    this.checkoutPolicyLoadFailed = false;
    this.checkoutBackendErrors = [];
    this.requiredFieldErrors = {};
    this.hasActiveCheckoutPolicy = !!policy?.hasActiveProfile;

    if (!policy || !this.hasActiveCheckoutPolicy) {
      this.requiredDocuments = [];
      this.policyCheckboxes = [];
      this.policyRequiredFields = [];
      this.selectedPolicyFiles = [];
      this.collectErrors();
      return;
    }

    const previousDocuments = new Map(this.requiredDocuments.map((item) => [item.documentName, item]));

    this.requiredDocuments = (policy.requiredDocuments || [])
      .filter((item) => item.isRequired)
      .sort((a, b) => a.displayOrder - b.displayOrder)
      .map((item) => {
        const previous = previousDocuments.get(item.documentName);
        return {
          ...item,
          uploadedFile: previous?.uploadedFile ?? null,
        };
      });

    this.policyCheckboxes = policy.requiredCheckboxes || [];
    this.policyRequiredFields = (policy.requiredFields || []).slice().sort((a, b) => a.displayOrder - b.displayOrder);

    if (this.selectedPolicyFiles.length > this.requiredDocuments.length) {
      this.selectedPolicyFiles = this.selectedPolicyFiles.slice(0, this.requiredDocuments.length);
    }

    this.collectErrors();
  }

  public async selectPolicyFiles(event: Event): Promise<void> {
    const input = event.target as HTMLInputElement;
    const newFiles = Array.from(input.files || []) as PolicyUploadFile[];
    if (newFiles.length === 0) {
      return;
    }

    const hasNonPdf = newFiles.some((file) => !this.isPdfFile(file));
    if (hasNonPdf) {
      this._toastrService.error(
        this.t('BENEFIT_SUMMARY.CHECKOUT_POLICY.ONLY_PDF_ALLOWED'),
        this.translate.transform('ERROR'),
        { toastClass: 'toast ngx-toastr', closeButton: true, timeOut: 8000 }
      );
      input.value = '';
      return;
    }

    const maxFiles = this.requiredDocuments.length;
    let mergedFiles = [...this.selectedPolicyFiles, ...newFiles];
    if (mergedFiles.length > maxFiles) {
      mergedFiles = mergedFiles.slice(0, maxFiles);
      this._toastrService.error(
        this.t('BENEFIT_SUMMARY.CHECKOUT_POLICY.TOO_MANY_FILES', { count: maxFiles }),
        this.translate.transform('ERROR'),
        { toastClass: 'toast ngx-toastr', closeButton: true, timeOut: 8000 }
      );
    }

    this.selectedPolicyFiles = mergedFiles;
    await this.assignPolicyFilesToRequiredDocuments();
    input.value = '';
  }

  public async deletePolicyFile(index: number): Promise<void> {
    this.selectedPolicyFiles.splice(index, 1);
    await this.assignPolicyFilesToRequiredDocuments();
  }

  private async assignPolicyFilesToRequiredDocuments(): Promise<void> {
    this.requiredDocuments = this.requiredDocuments.map((document) => ({
      ...document,
      uploadedFile: null,
    }));

    for (let i = 0; i < this.selectedPolicyFiles.length; i++) {
      const file = this.selectedPolicyFiles[i];
      try {
        const base64Value = await this.readFileAsBase64(file);
        this.requiredDocuments[i].uploadedFile = {
          name: file.name,
          base64Value,
        };
      } catch (_error) {
        this.requiredDocuments[i].uploadedFile = null;
        this._toastrService.error(
          this.t('BENEFIT_SUMMARY.CHECKOUT_POLICY.FILE_READ_FAILED'),
          this.translate.transform('ERROR'),
          { toastClass: 'toast ngx-toastr', closeButton: true, timeOut: 8000 }
        );
      }
    }

    this.checkoutBackendErrors = [];
    this.collectErrors();
  }

  private isPdfFile(file: File): boolean {
    return file.type === 'application/pdf' || file.name.toLowerCase().endsWith('.pdf');
  }

  public formatBytes(bytes: number, decimals = 2): string {
    if (!bytes) {
      return '0 Bytes';
    }

    const k = 1024;
    const dm = decimals <= 0 ? 0 : decimals;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
  }

  public getRequiredDocumentsInfoText(): string {
    const documentNames = this.requiredDocuments
      .map((document) => document.displayName)
      .filter((name) => !!name && name.trim().length > 0);

    if (documentNames.length === 0) {
      return '';
    }

    if (documentNames.length === 1) {
      return this.t('BENEFIT_SUMMARY.CHECKOUT_POLICY.REQUIRED_DOCUMENT_INFO_SINGLE', {
        documentName: documentNames[0],
      });
    }

    return this.t('BENEFIT_SUMMARY.CHECKOUT_POLICY.REQUIRED_DOCUMENT_INFO_MULTIPLE', {
      documentNames: documentNames.join(', '),
    });
  }

  public onRequiredConsentChange(): void {
    this.checkoutBackendErrors = [];
    this.collectErrors();
  }

  private readFileAsBase64(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result as string);
      reader.onerror = (error) => reject(error);
    });
  }

  private buildSubmittedRequiredDocuments(): Array<OrderSubmittedDocumentSubmissionModel> {
    return this.requiredDocuments.map((document) => ({
      name: document.documentName,
      uploadedFile: document.uploadedFile!,
    }));
  }

  private hasCheckoutPolicyRequirements(): boolean {
    return this.hasActiveCheckoutPolicy &&
      (this.requiredDocuments.length > 0 || this.policyCheckboxes.length > 0 || this.policyRequiredFields.length > 0);
  }

  public isCheckoutPolicyComplete(): boolean {
    if (!this.hasCheckoutPolicyRequirements()) {
      return true;
    }

    const hasAllDocuments = this.requiredDocuments.every((document) => !!document.uploadedFile?.base64Value);
    const hasAllConsents = this.requiredConsentsRef?.isComplete() ?? true;

    return hasAllDocuments && hasAllConsents;
  }

  private onCheckoutPolicyFail(error: any): void {
    this.checkoutPolicyLoadFailed = true;
    this.checkoutPolicy = null;
    this.hasActiveCheckoutPolicy = false;
    this.requiredDocuments = [];
    this.policyCheckboxes = [];
    this.policyRequiredFields = [];
    this.selectedPolicyFiles = [];
    this.checkoutBackendErrors = [];
    this.requiredFieldErrors = {};

    const apiErrors = error?.errors || error?.error?.errors || [];
    const messages = apiErrors.length
      ? apiErrors.map((item) => item.displayMessage || item.completeMessage || item.code || this.t('BENEFIT_SUMMARY.CHECKOUT_POLICY.LOAD_FAILED'))
      : error?.messages || [this.t('BENEFIT_SUMMARY.CHECKOUT_POLICY.LOAD_FAILED')];

    this._toastrService.error(
      messages[0] || this.t('BENEFIT_SUMMARY.CHECKOUT_POLICY.LOAD_FAILED'),
      this.translate.transform('ERROR'),
      { toastClass: 'toast ngx-toastr', closeButton: true, timeOut: 8000 }
    );
    this.collectErrors();
  }

  public onPostPartialOrderSuccess(
    data: PostOrderResponse
  ) {
    this.authenticationService.updateCurrentUserInfo();
    this._toastrService.success(
      this.translate.transform(
        'BENEFIT_SUBSCRIPTION_PAYMENT_RETRY.ORDER_SUCCESS'
      ),
      this.translate.transform('SUCCESS'),
      { toastClass: 'toast ngx-toastr', closeButton: true, timeOut: 3000 }
    );
    const needsCardPayment: boolean = data.isSuccess &&
      (
        (data.responseObject.url !== undefined && data.responseObject.url !== null && data.responseObject !== '') ||
        (data.responseObject.customerAction !== undefined && data.responseObject.customerAction !== null)
      );


    this.gAnalyticsService.addGeneralEventsAnalytics('event', 'purchase', {
      transaction_id: 'T_' + data.responseObject.orderId,
      value: this.benefit.price * this.quantity,
    tax: this.taxService.getTotalTaxAmount(this.benefitTaxes),
      currency: 'RON',
      items: [
        {
          item_id: this.benefit.id,
          item_sku: this.benefit.sku,
          item_name: this.benefit.name,
          item_category: this.benefit.categoryName,
          item_category_id: this.benefit.categoryId,
          item_brand: this.benefit.providerName,
          price: this.benefit.price,
          quantity: this.quantity,
          affiliation: this.benefit.providerName,
          vat_included: this.benefit.includesVat,
          vat_percentage: this.benefit.vatPercentage,
          card_payment_allowed: this.benefit.hasCreditCardAllowed(),
          tax_type: this.benefit.benefitTaxCategory,
          supplier_id: this.benefit.providerId,
          benefit_Type: this.benefit.benefitTypeId,
        }
      ]
    });

    if (!needsCardPayment) {
      let historyType = this.isSubscriptionBenefit() ? 'recurrent' : 'confirmed';
      this._router.navigate([
        '/' + this._route.snapshot.params['subdomain'] + '/benefits-history/' + historyType,
      ], { queryParams: { justOrdered: 'true' } });
    } else {
      this.authenticationService.updateCurrentUserInfo();
      this.orderId = data.responseObject.orderId;
      const subdomain = this._route.snapshot.params['subdomain'];
      redirectToPaymentGateway(data.responseObject, subdomain, this._router);
    }
  }

  public onPostOrderSuccess(data: PostOrderResponse) {
    this.gAnalyticsService.addGeneralEventsAnalytics('event', 'purchase', {
      transaction_id: 'T_' + data.responseObject.orderId,
      value: this.benefit.price * this.quantity,
      tax: this.taxService.getTotalTaxAmount(this.benefitTaxes),
      currency: 'RON',
      items: [
        {
          item_id: this.benefit.id,
          item_sku: this.benefit.sku,
          item_name: this.benefit.name,
          item_category: this.benefit.categoryName,
          item_category_id: this.benefit.categoryId,
          item_brand: this.benefit.providerName,
          price: this.benefit.price,
          quantity: this.quantity,
          affiliation: this.benefit.providerName,
          vat_included: this.benefit.includesVat,
          vat_percentage: this.benefit.vatPercentage,
          card_payment_allowed: this.benefit.hasCreditCardAllowed(),
          tax_type: this.benefit.benefitTaxCategory,
          supplier_id: this.benefit.providerId,
          benefit_Type: this.benefit.benefitTypeId,
        }
      ]
    });
    this._toastrService.success(
      this.translate.transform(
        'BENEFIT_SUBSCRIPTION_PAYMENT_RETRY.ORDER_SUCCESS'
      ),
      this.translate.transform('SUCCESS'),
      { toastClass: 'toast ngx-toastr', closeButton: true, timeOut: 3000 }
    );
    this.authenticationService.updateCurrentUserInfo();
    let historyType = this.isSubscriptionBenefit() ? 'recurrent' : 'confirmed';
    this._router.navigate([
      '/' + this._route.snapshot.params['subdomain'] + '/benefits-history/' + historyType,
    ], { queryParams: { justOrdered: 'true' } });
  }

  public onPostOrderFail(error: any) {
    const apiErrors: ResponseError[] = error?.errors || error?.error?.errors || [];

    const fieldSpecificCodes = new Set([
      'POLICY_PREREQUISITES.MISSING_REQUIRED_FIELD',
      'POLICY_PREREQUISITES.INVALID_REQUIRED_FIELD_VALUE',
      'POLICY_PREREQUISITES.DUPLICATE_REQUIRED_FIELD',
    ]);
    // The specific error identifier is returned in completeMessage (code is
    // often a generic bucket, e.g. "SD_GENERIC").
    const isFieldError = (item: ResponseError) =>
      item.fieldId != null && fieldSpecificCodes.has(item.completeMessage || item.code);
    const fieldErrors = apiErrors.filter(isFieldError);
    const genericErrors = apiErrors.filter((item) => !isFieldError(item));
    const fieldMessages = fieldErrors.map((item) => this.getCheckoutErrorMessage(item));

    this.requiredFieldErrors = fieldErrors.reduce((acc, item, index) => {
      acc[item.fieldId] = fieldMessages[index];
      return acc;
    }, {} as Record<number, string>);

    this.checkoutBackendErrors = genericErrors.length > 0 ? this.mapCheckoutBackendErrors(genericErrors) : [];

    if (apiErrors.some((item) => this.getCheckoutErrorMessage(item).includes('24PAY')) || error.messages?.[0]?.includes('24PAY')) {
      this.showErrorToast(apiErrors[0]?.displayMessage || error.messages?.[0] || 'An error occurred');
    } else {
      // Field-specific errors are shown both inline (above) and as a toast
      // here, so the user sees an immediate notification in addition to the
      // in-context message under the field.
      const messages = this.checkoutBackendErrors.length > 0 || fieldMessages.length > 0
        ? [...this.checkoutBackendErrors.map((item) => item.text), ...fieldMessages]
        : error.messages || [];

      messages.forEach((errorItem) => this.showErrorToast(errorItem));
    }
    this.collectErrors();
    this.userDashboardSubscription = this.authenticationService.currentUserInfo.subscribe((x) => {
      this.userInfoDashboard = x;
    });
  }

  private showErrorToast(message: string): void {
    this._toastrService.error(
      this.translate.transform(message),
      this.translate.transform('ERROR'),
      { toastClass: 'toast ngx-toastr', closeButton: true, timeOut: 3000 }
    );
  }

  private mapCheckoutBackendErrors(errors: ResponseError[]): ErrorMessage[] {
    return errors.map((error) => ({
      text: this.getCheckoutErrorMessage(error),
      className: 'not-eligible-warning font-small-3 mb-2 text-center',
      priority: OrderErrorPriority.BLOCKED,
    }));
  }

  /**
   * Resolves a human-readable message for a backend error. `displayMessage`
   * is tried first — it may itself be a translation key (e.g. a granular
   * field-validation reason code such as POLICY_REQUIRED_FIELD.EMAIL_EMPTY)
   * or plain human text; `this.t()` safely returns the input unchanged when
   * no matching translation exists, so both cases are handled uniformly.
   * Falls back to translating the semantic error code (completeMessage,
   * since `code` is often a generic bucket like "SD_GENERIC"), then to the
   * raw code/completeMessage, then to a generic message.
   */
  private getCheckoutErrorMessage(error: ResponseError): string {
    const semanticCode = error?.completeMessage || error?.code;
    return (error?.displayMessage && this.t(error.displayMessage))
      || (semanticCode && this.t(semanticCode))
      || error?.displayMessage
      || semanticCode
      || 'An error occurred';
  }

  /**
   * Get beneficiary
   */
  public loadBeneficiaries() {
    const params: PaginationCriteria = {
      start: 0,
      limit: 20,
    };
    this.benefitSummaryService
      .getBeneficiaries(params)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (data) => {
          this.onGetBeneficiarySuccess(data);
        },
        (error) => {
          this.onGetBeneficiaryFail(error);
        }
      );
  }

  public onGetBeneficiarySuccess(data: GetBeneficiariesResponse) {
    this.beneficiaries = data.responseObject.data;
  }

  public onGetBeneficiaryFail(error: HttpErrorResponse) { }

  /**
   * Add beneficiary
   */
  public addEditBeneficiary(
    action: string,
    beneficiary: Beneficiary | null = null
  ) {
    const modalRef = this.modalService.open(AddBeneficiaryComponent, {
      centered: true,
      backdrop: 'static',
    });

    modalRef.componentInstance.actionType = action;
    modalRef.componentInstance.selectedBeneficiary = beneficiary;

    modalRef.result.then((response) => {
      if (response[0]) {
        this.verifyCanOrder();
        if (action === 'edit') {
          this.beneficiaries.forEach((beneficiaryItem) => {
            if (beneficiaryItem.id === response[1].id) {
              beneficiaryItem = response[1];
            }
          });
          this._toastrService.success(
            this.translate.transform(
              'BENEFIT_SUMMARY.BENEFICIARY.EDIT_SUCCESS'
            ),
            this.translate.transform('SUCCESS'),
            { toastClass: 'toast ngx-toastr', closeButton: true, timeOut: 3000 }
          );
        } else {
          this._toastrService.success(
            this.translate.transform('BENEFIT_SUMMARY.BENEFICIARY.ADD_SUCCESS'),
            this.translate.transform('SUCCESS'),
            { toastClass: 'toast ngx-toastr', closeButton: true, timeOut: 3000 }
          );
          this.loadBeneficiaries();
        }
      }
    });
  }

  /**
   * Delete beneficiary
   */

  public deleteBeneficiary(beneficiary: Beneficiary) {
    const confirmAction = confirm(this.translate.transform('BENEFIT_SUMMARY.CONFIRM_BENEFICIARY_DELETE'));
    if (!confirmAction){
      return;
    }
    const params: Array<Patch> = [
      {
        op: 'replace',
        path: 'isDeleted',
        value: 'true',
      },
    ];

    this.benefitSummaryService
      .deleteBeneficiaries(params, beneficiary.id)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (data) => {
          this.onDeleteBeneficiarySuccess(data, beneficiary.id);
          this.verifyCanOrder();
        },
        (error) => {
          this.onDeleteBeneficiaryFail(error);
        }
      );
  }

  public onDeleteBeneficiarySuccess(data: BaseResponse, id: number) {
    if(+this.selectedBeneficiary === id) {
      this.selectedBeneficiary = '0';
    }
    this.beneficiaries = this.beneficiaries.filter((beneficiaryItem) => beneficiaryItem.id !== id);
    this.loadBeneficiaries();
    this._toastrService.success(
      this.translate.transform('BENEFIT_SUMMARY.BENEFICIARY.DELETE_SUCCESS'),
      this.translate.transform('SUCCESS'),
      { toastClass: 'toast ngx-toastr', closeButton: true, timeOut: 3000 }
    );
  }

  public onDeleteBeneficiaryFail(error: HttpErrorResponse) { }

  /**
   * Get documents
   */
  public loadDocuments() {
    const params: GetDocumentsRequest = {
      paginationCriteria: {
        start: 0,
        limit: 10,
      },
      benefitId: this.benefitId,
    };
    this.benefitSummaryService
      .getBenefitDocuments(params)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (data) => {
          this.onGetDocumentsSuccess(data);
        },
        (error) => {
          this.onGetDocumentsFail(error);
        }
      );
  }

  public onGetDocumentsSuccess(data: GetBenefitDocumentsResponse) {
    this.documents = data.responseObject.data;
    this.documents = data.responseObject.data.map((document) => ({
      benefitName: document.benefitName,
      benefitDescription: document.benefitDescription,
      documentUrl: document.documentUrl,
      checked: false,
    }));

  }

  public onGetDocumentsFail(error: HttpErrorResponse) { }

  public showLegal(document: BenefitDocument) {
    const modalRef = this.modalService.open(ShowBenefitComponent, {
      centered: true,
      backdrop: 'static',
    });
    modalRef.componentInstance.document = document;
    modalRef.componentInstance.type = this.isPensionOrInsurance(this.benefit) ? 'fixed' : 'flexible';
    modalRef.result.then((response) => {
      if (response[0]) {
        this.documents.map((documentItem) => {
          if (documentItem.documentUrl === response.documentItem) {
            documentItem = response;
          }
        });
      }
    });
  }

  /**
   * Get user addresses
   */
  public getUserAddresses(type?: string) {
    const params: GetUserAddressesRequest = {
      paginationCriteria: {
        start: 0,
        limit: 5,
      },
      userId: this.authenticationService.currentUserValue.userId,
      addressType: type === 'billing' ? 2 : 1,
    };
    this.userService
      .getUserAddresses(params)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (data) => {
          this.onGetUserAddressesSuccess(data, type);
        },
        (error) => {
          this.onGetUserAddressesFail(error);
        }
      );
  }

  public onGetUserAddressesSuccess(
    data: GetUserAddressesResponse,
    type: string
  ) {
    if (type === 'billing') {
      this.billingAddresses = data.responseObject.data;
      if (this.billingAddresses.length > 0) {
        this.selectedBillingAddress = this.billingAddresses[0].id;
      }

      this.processorIsRaiffeisen = this.isProcessorRaiffeisen();
      if(this.processorIsRaiffeisen) {
        this.formRaiffeisen = new FormGroup({
          [RaiffeisenFormData.BRANCH]: new FormControl("", Validators.required),
          [RaiffeisenFormData.EMPLOYER]: new FormControl(this.userCompanyInfo.companyName),
        });
        this.onBillingAddressChange(this.selectedBillingAddress);
      }
    } else {
      this.shippingAddresses = data.responseObject.data;
      if (this.shippingAddresses.length > 0) {
        this.selectedShippingAddress = this.shippingAddresses[0].id;
      }
    }
  }

  public onGetUserAddressesFail(error: HttpErrorResponse) { }

  /**
   * Add address
   */
  public addEditAddress(
    type: string,
    action: string,
    address: UserAddress | null = null
  ) {
    const modalRef = this.modalService.open(AddAddressComponent, {
      centered: true,
      backdrop: 'static',
    });
    modalRef.componentInstance.actionType = action;
    modalRef.componentInstance.addressType = type;
    modalRef.componentInstance.selectedAddress = address;

    modalRef.result.then((response) => {
      if (response[0]) {
        if (action === 'edit') {
          this.billingAddresses.forEach((addressItem) => {
            if (addressItem.id === response[1].id) {
              addressItem = response[1];
            }
          });
          if (this.selectedBillingAddress === response[1].id) {
            this.onBillingAddressChange(this.selectedBillingAddress);
          }
          this._toastrService.success(
            this.translate.transform('BENEFIT_SUMMARY.ADDRESSES.EDIT_SUCCESS'),
            this.translate.transform('SUCCESS'),
            { toastClass: 'toast ngx-toastr', closeButton: true, timeOut: 3000 }
          );
        } else {
          if (type === 'shipping') {
            this.getUserAddresses('shipping');
            this.getUserAddresses('billing');
          } else {
            this.getUserAddresses('billing');
          }
          this._toastrService.success(
            this.translate.transform('BENEFIT_SUMMARY.ADDRESSES.ADD_SUCCESS'),
            this.translate.transform('SUCCESS'),
            { toastClass: 'toast ngx-toastr', closeButton: true, timeOut: 3000 }
          );
        }
      }
    });
  }

  /**
   * Delete address
   */
  public deleteAddress(address: UserAddress, type: string) {
    const params: Array<Patch> = [
      {
        op: 'replace',
        path: 'isDeleted',
        value: 'true',
      },
    ];

    this.userService
      .deleteAddresses(params, address.id)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (data) => {
          this.onDeleteSuccess(data, type, address.id);
        },
        (error) => {
          this.onDeleteFail(error);
        }
      );
  }

  public onDeleteSuccess(data: BaseResponse, type, id: number) {
    if (type === 'shipping') {
      this.shippingAddresses = this.shippingAddresses.filter((addressItem) => addressItem.id !== id);
    } else {
      this.billingAddresses = this.billingAddresses.filter((addressItem) => addressItem.id !== id);
      if (this.selectedBillingAddress === id) {
        this.selectedBillingAddress = 0;
        this.onBillingAddressChange(this.selectedBillingAddress);
      }
    }
    this._toastrService.success(
      this.translate.transform('BENEFIT_SUMMARY.ADDRESSES.DELETE_SUCCESS'),
      this.translate.transform('SUCCESS'),
      { toastClass: 'toast ngx-toastr', closeButton: true, timeOut: 3000 }
    );
  }

  public onDeleteFail(error: any) {
    error.messages.forEach((errorItem) => {
      this._toastrService.error(
        this.translate.transform(errorItem),
        this.translate.transform('ERROR'),
        { toastClass: 'toast ngx-toastr', closeButton: true, timeOut: 3000 }
      );
    });
  }

  /**
   * Helpers
   */

  public extractFormValues(formControlElement: HTMLFormElement): Array<DynamicAttribute> | null {
    if (!(formControlElement instanceof HTMLFormElement)) {
      return null;
    }

    // Initialize an empty object to store key-value pairs
    const formData: Array<DynamicAttribute> = [];

    Array.from(formControlElement.elements).forEach((element: Element) => {
      const formElement = (element as HTMLInputElement | HTMLSelectElement);

      const dynamicAttrbute = <DynamicAttribute> {
        propertyName: formElement.name,
        propertyValue: formElement.type === 'checkbox' ? (formElement as HTMLInputElement).checked : formElement.value
      };

      if (element.tagName === 'SELECT'){
        formData.push(dynamicAttrbute);
      }

      if(element.tagName === 'INPUT' && ['text', 'checkbox', 'radio'].includes((element as HTMLInputElement).type)) {
        if(formElement.value) {
          formData.push(dynamicAttrbute);
        }
      }

      if(element.tagName === 'INPUT' && ['number'].includes((element as HTMLInputElement).type)) {
        if(formElement.value) {
          formData.push(dynamicAttrbute);
        }
      }
    });

    return formData;
  }

  private extractRaiffeisenFormValues(): Array<DynamicAttribute> | null {
    if (!this.formRaiffeisen) {
      return null;
    }

    // Initialize an empty object to store key-value pairs
    const formData: Array<DynamicAttribute> = [];

    Object.entries(this.formRaiffeisen.controls).forEach(([name, control]) => {
      const dynamicAttribute = <DynamicAttribute> {
        propertyName: name,
        propertyValue: control.value,
      };

      switch (name) {
        case RaiffeisenFormData.BRANCH:
          dynamicAttribute.propertyValue = (control.value as RaiffeisenBranchOption).branchDetails.id
          break;
      }

      formData.push(dynamicAttribute);
    });

    return formData;
  }

  public checkFormValues(formElement: HTMLFormElement): boolean {
    if (this.benefit.dynamicAttributesHtml && this.benefit.dynamicAttributesHtml.length > 0 && !this.listenersSet) {
      this.listenersSet = true;
      Array.from(formElement.elements).forEach((element: Element) => {
        // Type guard to check if element has setCustomValidity
        if ('setCustomValidity' in element) {
          const formControl = element as HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement;

          formControl.addEventListener('invalid', (event) => {
            const target = event.target as typeof formControl;
            if (target.validity.valueMissing) {
              target.setCustomValidity(this.dynamicFieldRequiredError);
            } else if (target.validity.patternMismatch) {
              target.setCustomValidity(this.dynamicFieldPatternError);
            }
          });

          formControl.addEventListener('input', () => formControl.setCustomValidity(''));
        }
      });
    }

    let formHasErrors = !formElement.checkValidity();
    formElement.reportValidity();
    return formHasErrors;
  }

  public getNormalizedString(str: string, replaceHypen: boolean = true) {
    var result = str.toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "");
    return replaceHypen ? result.replace('-', ' ') : result;
  }

  public checkDocsStatus() {
    if(this.isPensionOrInsurance(this.benefit)) {
      return true;
    }

    let flag = true;
    this.documents.forEach((documentItem) => {
      if (!documentItem.checked) {
        flag = false;
      }
    });
    return flag;
  }

  public isPensionOrInsurance(benefit: FlexibleBenefit) {
    return benefit && benefit.benefitTypeId && (benefit.benefitTypeId === BenefitType.MedicalServicesOrInsurance || benefit.benefitTypeId === BenefitType.PrivatePensionPillarIII)
  }

  public checkDocument(document: BenefitDocument) {
    document.checked = !document.checked;
  }

  public checkIfShippingIsRequired() {
    if (
      this.benefit.shippingType === ShippingType.Voucher ||
      this.benefit.shippingType === ShippingType.CardRecharge ||
      this.benefit.shippingType === ShippingType.Email
    ) {
      return true;
    } else {
      return this.selectedShippingAddress !== 0;
    }
  }

  checkIfBillingAddressIsRequired() {
    if(this.benefit.hasCreditCardAllowed() === true && (this.usesDifferenceWithCard === true || this.isCardPayment)){
      return this.selectedBillingAddress !== 0;
    } else if (this.hasBillingAddress()){
      return this.selectedBillingAddress !== 0;
    } else {
      return true;
    }
  }

  public getGiftTicketConditionsByBenefit = () => {
    const data =
      {
        'companyId': this.companyId,
        'benefitId': this.benefitId
      };

    this._giftTicketService.getByBenefit(data).subscribe(e => {
      this.giftTickets = e.responseObject;
      this.verifyCanOrder();
    });
  };

  public onBeneficiaryChange() {
    if (!this.activeEventName) {
      this.getTaxes();
    }
    this.getSubscriptionPayments();
    this.verifyCanOrder();
  }

  public loadActiveEventName() {
    this.dashboardService.getCompanyEvents(this.subdomain)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe({
        next: response => {
          if (response.responseObject?.length) {
            const today = new Date();
            const activeEvent = response.responseObject.find(e => {
              const end = new Date(e.endDate);
              end.setHours(23, 59, 59, 999);
              return new Date(e.startDate) <= today && today <= end
                && e.benefits.some(b => b.id === Number(this.benefitId));
            });
            const hasGiftQuota = (this.authenticationService.currentUserInfoValue?.numberOfGiftTickets ?? 0) > 0;
            this.activeEventName = (activeEvent && hasGiftQuota) ? activeEvent.name : null;
          } else {
            this.activeEventName = null;
          }
          this.verifyCanOrder();
        },
        error: () => {
          this.activeEventName = null;
          this.verifyCanOrder();
        }
      });
  }

  public verifyCanOrder() {
    this.canBeOrdered = true;
    this.cardPaymentBlocked = false;
    this.verifyCanOrderWarningMessage = null;
    this.remainingEventLimit = null;
    this.eventLimitOverflowAmount = null;

    if (!this.activeEventName) {
      this.collectErrors();
      return;
    }

    const beneficiaries = this.selectedBeneficiary !== '0' ? [parseInt(this.selectedBeneficiary, 10)] : [];

    const data = {
      'benefitId' : this.benefitId,
      'quantity' : this.quantity,
      'beneficiaries': beneficiaries,
      'payWithCardOnly': this.isCardPayment
    };
    this._giftTicketService.verifyCanOrder(data)
      .subscribe({
        next: (res: any) => {
          this.remainingEventLimit = res?.responseObject?.remainingEventLimit ?? null;
          this.eventLimitOverflowAmount = res?.responseObject?.eventLimitOverflowAmount ?? null;
          const taxModel = res?.responseObject?.taxModel;
          if (taxModel) {
            const hasNoTaxes = this.taxService.getTotalTaxAmount(taxModel) === 0;
            this.onGetTaxesSuccess({ responseObject: taxModel } as GetTaxInfoResponse);
            this.taxAndFeesTooltipText = this.taxAndFeesService.setTaxAndFeesTooltip(
              this.benefit,
              hasNoTaxes,
              true
            );
          }

          // onGetTaxesSuccess() already calls collectErrors() in its non-card branch,
          // so only call it here when that path didn't run.
          if (!taxModel || this.isCardPayment) {
            this.collectErrors();
          }
        },
        error: (error: any) => {
          if (error.messages?.length) {
            const message = error.messages[0];
            if (message.includes('CARD_NOT_ALLOWED_DURING_EVENT')) {
              this.cardPaymentBlocked = true;
            } else {
              // Order is still allowed but event conditions weren't fully met.
              // Normal taxes (from getTaxes) apply — store as a warning so the user knows why.
              this.verifyCanOrderWarningMessage = message;
            }
          }

          // Always refresh errors. There might be cases where an error
          // without a message is received from the BE
          this.collectErrors();
        }
      });
  }

  collectErrors() {
    const messages: ErrorMessage[] = [];
    const commonErrClass = 'not-eligible-warning font-small-3 mb-2';
    const commonInfoClass = 'text-warning font-small-3 mb-2';

    if (this.isGiftTypeBenefit) {
      // GiftTicket in event — card blocked or budget insufficient covered by card
      if (this.activeEventName && (this.cardPaymentBlocked || this.effectiveCardPaymentAmount > 0)) {
        messages.push({
          text: 'ORDER_TICKET.CARD_NOT_ALLOWED_DURING_EVENT_NO_AMOUNT',
          className: commonErrClass + ' text-center',
          priority: OrderErrorPriority.BLOCKED
        });
      }
    } else {
      // non-GiftTicket overflow with taxes applied on difference
      if (this.eventLimitOverflowAmount > 0 &&
        this.taxService.getTotalTaxAmount(this.benefitTaxes) > 0 &&
        !(this.benefit.hasCreditCardAllowed() && this.effectiveCardPaymentAmount > 0)
      ) {
        messages.push({
          text: 'ORDER_TICKET.EVENT_LIMIT_OVERFLOW',
          translationParams: { overflow: this.eventLimitOverflowAmount },
          className: commonInfoClass + ' text-center',
          priority: OrderErrorPriority.COST_INFO
        });
      }
    }

    // warning when event conditions not fully met (e.g. INVALID_SELF) but order is still allowed
    if (this.verifyCanOrderWarningMessage) {
      messages.push({
        text: this.t('ORDER_TICKET.TAXES_REASON') + this.t(this.verifyCanOrderWarningMessage),
        className: 'text-warning font-small-3 mb-2 text-center',
        priority: OrderErrorPriority.COST_INFO
      })
    }

    // Generic not eligible (non-event)
    if (!this.canBeOrdered && !this.cardPaymentBlocked &&
      !(this.activeEventName && this.isGiftTypeBenefit)) {
      const extraClass = ' ng-star-inserted text-center';
      if (!this.canNotFulfillPayment) {
        messages.push({
          text: 'BENEFIT_SUMMARY.NOT_ELIGIBLE_FOR_BENEFIT',
          className: commonErrClass + extraClass,
          priority: OrderErrorPriority.BLOCKED
        });
      } else {
        const text =
          this.t(
            'SUBSCRIPTION_PAYMENT.PAYMENT_CAN_NOT_BE_FULFILLED',
            {
              monthlyBudget: this.userInfoDashboard.monthlyBudget,
              month: this.t(this.datePipe.transform(this.canNotFulfillPayment.date, 'MMMM')?.toUpperCase()),
              year: this.datePipe.transform(this.canNotFulfillPayment.date, 'yyyy'),
              subscriptionAmount: this.canNotFulfillPayment.paymentTotal
            }
          );
        messages.push({
          text,
          className: commonErrClass + extraClass,
          priority: OrderErrorPriority.BLOCKED
        });
      }
    }

    if (this.checkoutPolicyLoadFailed) {
      messages.push({
        text: 'BENEFIT_SUMMARY.CHECKOUT_POLICY.LOAD_FAILED',
        className: commonErrClass + ' text-center',
        priority: OrderErrorPriority.BLOCKED
      });
    } else if (this.hasCheckoutPolicyRequirements() && !this.isCheckoutPolicyComplete()) {
      messages.push({
        text: 'BENEFIT_SUMMARY.CHECKOUT_POLICY.INCOMPLETE',
        className: commonErrClass + ' text-center',
        priority: OrderErrorPriority.ACTION_REQUIRED
      });
    }

    if (this.checkoutBackendErrors.length > 0) {
      messages.push(...this.checkoutBackendErrors);
    }

    this.errorMessages = messages.sort(
      (a, b) =>
        (a.priority ?? Number.MAX_SAFE_INTEGER) - (b.priority ?? Number.MAX_SAFE_INTEGER)
    );
  }

  get isGiftTypeBenefit(): boolean {
    return this.benefit?.benefitTypeId === BenefitType.GiftTicket;
  }

  get effectiveTaxCategory(): number {
    // Within an active event and within the limit the backend returns 0 taxes (category 1).
    if (this.activeEventName && this.benefitTaxes && this.taxService.getTotalTaxAmount(this.benefitTaxes) === 0) {
      return 1;
    }
    return this.benefit?.benefitTaxCategory;
  }

  get hasCamTax(): boolean {
    return (this.benefitTaxes?.camTaxValue ?? 0) > 0;
  }

  get camTaxTooltipKey(): string {
    const taxDistributionType = this.benefitTaxes?.taxDistributionType;
    if (taxDistributionType === CompanyTaxDistribution.EMPLOYEE) {
      return 'BENEFIT_SUMMARY.SUMMARY_DETAILS.CAM_TAX_TOOLTIP_EMPLOYEE';
    }

    return 'BENEFIT_SUMMARY.SUMMARY_DETAILS.CAM_TAX_TOOLTIP_COMPANY_OR_SALARY';
  }

  get camTaxTooltipParams(): Record<string, number> {
    return { percentage: this.roundTaxPercentage(this.benefitTaxes?.camTaxPercentage ?? 0) };
  }

  get amountWithCamTax(): number {
    return this.taxService.getAmountWithCam(this.benefitTaxes?.amountWithVat, this.benefitTaxes?.camTaxValue);
  }

  get totalTaxAmount(): number {
    return this.taxService.getTotalTaxAmountWithoutCAM(this.benefitTaxes);
  }

  private roundTaxPercentage(value: number): number {
    return Math.round(value * 100) / 100;
  }

  /**
   * Returns the card payment amount adjusted for all available budgets (standard + cashback).
   * Only meaningful for GiftTicket/GiftVoucher inside an active event — returns 0 otherwise.
   */
  get effectiveCardPaymentAmount(): number {
    if (!this.activeEventName || !this.isGiftTypeBenefit) return 0;
    return this.usesDifferenceWithCard ? (this.differenceWithCard ?? 0) : 0;
  }

  public isTicketBenefit(): boolean {
    const ticketBenefitTypes = [BenefitType.MealTicket, BenefitType.GiftTicket, BenefitType.CultureTicket, BenefitType.VacationTicket];
    if (!this.benefit) {
      return false;
    }

    return ticketBenefitTypes.findIndex(x => x === this.benefit.benefitTypeId) > -1;
  }

  public isSubscriptionBenefit() {
    if (!this.benefit) {
      return false;
    }

    if (!(this.benefit.acquisitionType === AcquisitionType.Subscription)) {
      return false;
    }

    return true;
  }

  public isAutoOrderBenefit(){
    if(!this.benefit){
      return false;
    }

    return this.benefit.acquisitionType === AcquisitionType.AutoOrder;
  }

  public is24PayBenefit(){
    if (!this.benefit) {
      return false;
    }

    if (this.benefit.providerName.includes('24Pay')) {
      return true;
    }

    return false;
  }

  public isProcessorRaiffeisen() {
    if (!this.benefit || !this.benefit.processorCode) {
      return false;
    }

    return this.benefit.processorCode.includes("raiffeisen");
  }

  public hasDynamicFields(){
    if(this.benefit.dynamicAttributesHtml){
      return true;
    } else{
      return false;
    }
  }

  public isBillingContactNameSameAsUsername() {
    if (this.selectedBillingAddress === 0) return false;
    const billingAddress = this.getBillingAddress();
    const username = this.userInfoDashboard.lastName + ' ' + this.userInfoDashboard.firstName;
    return billingAddress.contactPersonName === username;
  }

  private getSubscriptionPayments(){
    if (this.benefitIsSubscription) {
      this.benefitSummaryService.getSubscriptionPayments(this.benefitId, this.selectedBeneficiary !== '0').subscribe(
        (payments: GetSubcriptionPaymentsResponse) => {
          this.subscriptionPayments = payments.responseObject;
          // Salary subscriptions are withheld from salary, not charged to the monthly
          // budget — the budget fulfillment check doesn't apply.
          this.canNotFulfillPayment = this.isSalaryPayment
            ? undefined
            : this.subscriptionPayments.find(sp => sp.canBeFulfilled === false);
          if(this.canNotFulfillPayment !== undefined) {
            this.canBeOrdered = false;
          }

          this.collectErrors();
        }
      );
    }
  }

  readonly PricingPlan = PricingPlan;
  public showTaxesForCompany: boolean;

  onAutoOrderSettingsChanged(autoOrderSettings: { isAutoOrderEnabled: boolean; hasDynamicQuantity: boolean }) {
    this.isAutoOrderEnabled = autoOrderSettings.isAutoOrderEnabled;
    this.dynamicQuantity = autoOrderSettings.hasDynamicQuantity;
  }

  getBillingAddress() {
    return this.billingAddresses.find(a => a.id === this.selectedBillingAddress);
  }

  onBillingAddressChange(newBillingAddressId: number) {
    if (this.processorIsRaiffeisen) {
      this.formRaiffeisen.get(RaiffeisenFormData.BRANCH)?.reset();
    } else {
      // If the billing address changes but the processor is NOT Raiffeisen
      // the logic afterwards (specific for a Raiffeisen benefit) should not execute
      return;
    }
    if (newBillingAddressId !== 0) {
      const billingAddress = this.getBillingAddress();
      const countyName = billingAddress.county;
      const cityName = billingAddress.city;

      this.populateRaiffeisenBranchesList(countyName, cityName);
    } else {
      this.raiffeisenBranchesOptions = undefined;
    }
  }

  raiffeisenBranchesSearchFn = (term: string, item: RaiffeisenBranchOption) => {
    return this.getNormalizedString(item.displayName, false)
      .includes(this.getNormalizedString(term, false));
  };

  populateRaiffeisenBranchesList = (countyName: string | undefined, cityName: string | undefined) => {
    this.raiffeisenBranchesOptions = undefined;
    if (!countyName) return;
    const normalizedCountyName = this.getNormalizedString(countyName);
    if (this.raiffeisenBranches[normalizedCountyName] === undefined) {
      this.benefitSummaryService.getRaiffeisenBranches(normalizedCountyName)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe({
          next: (data) => {
            this.raiffeisenBranches[normalizedCountyName] = data.responseObject;
            this.updateRaiffeisenBranchesList(countyName, cityName);
          }
        });
    } else {
      this.updateRaiffeisenBranchesList(countyName, cityName);
    }
  }

  private updateRaiffeisenBranchesList = (countyName: string | undefined, cityName: string | undefined)=> {
    this.raiffeisenBranchesOptions = [];
    const normalizedCountyName = this.getNormalizedString(countyName);
    Object.keys(this.raiffeisenBranches[normalizedCountyName]).forEach(city => {
      const localRaiffeisenBranches = this.raiffeisenBranches[normalizedCountyName][city];
      this.raiffeisenBranchesOptions.push(...(localRaiffeisenBranches
        .map(branch => {
          return {
            countyName: countyName,
            cityName: city,
            branchDetails: branch,
            displayName: `${branch.name} - ${city} - ${branch.address}`,
          }
        }))
      );
    })

    if (!cityName || cityName.length <= 0) {
      return;
    }

    const normalizedCityInput = this.getNormalizedString(cityName);
    const filteredRaiffeisenBranches = this.raiffeisenBranchesOptions
      .filter(branchOption => {
        const normalizedCityBranch = this.getNormalizedString(branchOption.cityName);

        return normalizedCityBranch.includes(normalizedCityInput);
      });

    if (filteredRaiffeisenBranches.length > 0)
      this.raiffeisenBranchesOptions = filteredRaiffeisenBranches;
  }

  copyCurrentBranchAddress(event: MouseEvent) {
    event.stopPropagation();
    event.preventDefault();

    const selectedBranchOption = this.formRaiffeisen.get(RaiffeisenFormData.BRANCH)?.value;
    if (selectedBranchOption) {
      const text = `Raiffeisen, ${selectedBranchOption.branchDetails.address}, ${selectedBranchOption.cityName}, ${selectedBranchOption.countyName}`;
      navigator.clipboard.writeText(text)
        .then(
          () => {
            this._toastrService.success(
              this.translate.transform('RAIFFEISEN.BENEFIT_SUMMARY.COPY_SUCCESS'),
              this.translate.transform('SUCCESS'),
              { toastClass: 'toast ngx-toastr', closeButton: true, timeOut: 3000 }
            );
          },
          () => {
            this._toastrService.error(
              this.translate.transform('RAIFFEISEN.BENEFIT_SUMMARY.COPY_FAIL'),
              this.translate.transform('ERROR'),
              { toastClass: 'toast ngx-toastr', closeButton: true, timeOut: 3000 }
            );
          }
        )
    }
  }

  protected readonly BenefitPaymentType = BenefitPaymentType;
  protected readonly RaiffeisenFormData = RaiffeisenFormData;

  // Shorthand for `this.translate.transform(...)` — keeps translation calls
  // concise and consistent across the component.
  private t(key: string, params?: Record<string, unknown>): string {
    return this.translate.transform(key, params);
  }
}
